import { getMemberPersonalDetails } from '@vista-digital/occ-domain';
import { mapMemberPersonalDetailsToMemberFormData } from '../mappers/map-member-personal-details-to-member-form-data';
export const getInitialMemberFormData = () => {
    const personalDetails = getMemberPersonalDetails();
    return personalDetails ? mapMemberPersonalDetailsToMemberFormData(personalDetails) : undefined;
};
//# sourceMappingURL=get-initial-member-form-data.js.map